<template>
  <v-container fluid class="privatstep4 mb-5 pa-0">

          <div class="semanticsection-title2 first">
            <span class="primary--text ueber">Vertragsdaten</span>
          </div>

          <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
                 no-gutters>
            <v-col v-if="!aenderung"
                   cols="12"
                   sm="6">
              <date-field v-model="versicherungsbeginn"
                          v-validate="{ required: true, date_format: ['DD.MM.YYYY'], date_between: [minVersBeginn, maxVersBeginn, true], excluded: '29.02.2024' }"
                          :error-messages="errors.collect('versicherungsbeginn')"
                          data-vv-as="Versicherungsbeginn"
                          hint="tt.mm.jjjj"
                          class="required"
                          name="versicherungsbeginn"
                          label="Versicherungsbeginn" />

            </v-col>
            <v-col cols="12"
                   sm="6">
              <date-field v-model="hauptfaelligkeit"
                          v-validate="{date_format:['DD.MM.'], excluded: '29.02.'}"
                          :error-messages="errors.collect('hauptfaelligkeit')"
                          no-year
                          hint="tt.mm."
                          name="hauptfaelligkeit"
                          label="abweichende Hauptfälligkeit" />
            </v-col>
          </v-row>
          <v-row no-gutters>

            <span class="primary--text ueber semanticsection-title2">Vorversicherungen und Leistungsfälle Antragsteller</span>


            <vor-versicherungen :state-path="`${statePath}.vn`"
                                form-ref="vorvervn-form" />

          </v-row>
          <template v-if="this.$store.getters.hasMvp(statePath)">
            <v-col cols="12"
                    class="semanticsection-title2">
              <span class="primary--text ueber ">Vorversicherungen und Leistungsfälle mitversicherte Person</span>
            </v-col>
            <vor-versicherungen :state-path="`${statePath}.mvp`"
                                form-ref="vorvermvp-form" />
            <!-- vor-versicherung state-path="b.vorversicherung.1"
                              form-ref="vorver-mvp-0" /-->
          </template>

          <wohneinheiten :state-path="statePath" />

          <template v-if="!aenderung">

            <v-row no-gutters>
              <v-col cols="12"
                      class="semanticsection-title2">
                <span class="primary--text ueber">Zusätzliche Mitteilungen</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12"
                      class="textarea-box">
                <v-text-field v-model="anmerkungen"
                              :counter="200"
                              maxlength="200"
                              clearable
                              class="mitteilungen ma-0" />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12"
                      class="semanticsection-title2">
                <div class="primary--text ueber">Zusätzliche Dokumente</div>
                <div v-if="showSfHint"
                     class="dmb-form-text">
                  Sofern die schadenfreie Zeit beim Vorversicherer angerechnet werden soll, bitte Schadenspiegel und letzte Police dem Antrag 
                  beifügen (vgl. <a
                  :href="highlightLinkSuS"
                  target="_blank"
                  class="primary--text"
                >Highlight-Blatt Schnell & Sicher</a>). 
                </div>
              </v-col>
              <file-upload-multi state-path="b"
                                 class="pa-0" />
            </v-row>

            <v-row v-if="needsMaknummer"
                   no-gutters>
              <v-col cols="12"
                      class="semanticsection-title2">
                <span class="primary--text ueber">Maklernummer</span>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="maknummer"
                              v-validate="'required'"
                              :error-messages="errors.collect('maknummer')"
                              data-vv-as="Zusätzliche Makleridentifikationsnummer"
                              class="required"
                              name="maknummer"
                              label="Zusätzliche Makleridentifikationsnummer" />
              </v-col>
            </v-row>

          </template>

    <v-row class="stepperbuttons">
      <v-btn id="back4"
             color="primary"
             class="standard-button"
             @click="$emit('step-back')">Zurück
      </v-btn>
      <v-spacer />
      <v-btn id="next4"
             color="primary"
             class="standard-button"
             @click="$emit('step-forward')">Weiter
      </v-btn>
    </v-row>

  </v-container>

</template>

<script>
import VorVersicherungen from "@/components/privatkundenrechner/VorVersicherungen.vue";
import Wohneinheiten from "@/components/privatkundenrechner/Wohneinheiten.vue";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import FileUploadMulti from "@/components/FileUploadMulti";
import DateField from "../DateField";
import {RIGHTS} from "@/store/user";
import {getDateString} from "@/helper/dateService";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";

export default {
  name: "PrivatStep4",
  components: { DateField, VorVersicherungen, Wohneinheiten, FileUploadMulti },
  mixins: [twowayBinding, ValidationMixin, contentLoadingMixin(["HL_SUS"])],
  props: {
    aenderung: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    minVersBeginn() {
      return getDateString(new Date(new Date().setDate(new Date().getDate() + 1)));
    },
    maxVersBeginn() {
      const now = new Date();
      const nowPlusOneYear = new Date(now.setFullYear(now.getFullYear() + 1));
      return getDateString(nowPlusOneYear);
    },
    ...mapTwoWay([
      "versicherungsbeginn",
      "hauptfaelligkeit",
      "invitatio",
      "werbezwecke",
      "anmerkungen",
      "maknummer"
    ]),
    highlightLinkSuS() {
      return this.HL_SUS ? this.HL_SUS.items[0].link : null;
    },
    needsMaknummer() {
      return this.$store.getters.checkAuthorization(RIGHTS.MAKLERNUMMER);
    },
    showSfHint() {
      const state = this.$store.state[this.statePath];
      return state && state.sus && state.vn.hasvorversicherung;
    }
  }
};
</script>
<style>
.privatstep4 .step2--header {
  font-size: 24px;
  font-weight: 300;
}

.privatstep4 .semanticsection-title2.mt40 {
  margin-top: 40px !important;
}

.privatstep4 .textarea-box {
  /*verify 12px for ipad and smaller*/
  padding-right: 12px;
}

.privatstep4 .mitteilungen {
  max-width: 100% !important;
}

.privatstep4 .input-group.input-group--selection-controls.vtfy-lined-input {
  /*make checkboxes align with text-inputs  */
  padding-top: 18px;
}

.privatstep4 .btn-add {
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

.privatstep4 .custom-label-inputgroup {
  display: flex;
  align-items: flex-start;
}

.privatstep4 .custom-label-inputgroup .mylabel {
  margin-left: 8px;
  margin-bottom: 56px;
  width: 100%;
  font-size: 16px;
}

.privatstep4 .custom-error-text {
  font-size: 12px;
  min-height: 1.5em;
}
.privatstep4 .v-input--radio-group__input .v-radio:not(:last-child) {
  margin-right: 48px!important;
}

.privatstep4 .hint {
  font-size: 14px !important;
  font-weight: 400;
}
</style>
